export default function galleryToggle() {
    document.querySelectorAll('.ikos-gallery-item').forEach( node => {
        const button = node.querySelector('.ikos-popover-button');
        const content = node.querySelector('.ikos-popover-content');

        // exit if not necessary
        if ( ! button || ! content ) return;


        button.addEventListener( 'click', function () {
            node.classList.add('ikos-is-active');
        })

        node.addEventListener("mouseleave", function () {
            node.classList.remove('ikos-is-active');
        })


    } )
}
